import actionTypes from '../../actions/actionTypes';

const initialState = {
    promptOtp: false,
    username: '',
    otpDestination: '',
    onOtpVerified: null,
};

const OTPReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PROMPT_OTP:
            return {
                ...state,
                promptOtp: action.payload.promptOtp,
            };
        case actionTypes.SET_OTP_CONFIGURATION:
            return {
                ...state,
                username: action.payload.username ?? state.username,
                otpDestination: action.payload.otpDestination ?? state.otpDestination,
                onOtpVerified: action.payload.onVerified ?? state.onOtpVerified,
            };
        case actionTypes.RESET_OTP_CONFIGURATION:
            return initialState;
        default:
            return state;
    }
};

export default OTPReducer;
